'use client';

import { useEffect } from 'react';
import { getThemeRoute } from '#/lib/theme-config';

export default function Routes({theme}: {theme: string}) {

  useEffect(() => {
    const routes = document.querySelector('[data-ghost-routes]')
    const wrapper = document.querySelector('[data-routes-placeholder]');

    if (routes && wrapper) {
      wrapper.append(routes)
      routes.classList.remove('hidden')
      routes.classList.add('block')
    }
  }, []);

  const themeRouting = getThemeRoute(theme)[0]

  if (!themeRouting) { 
    return <></>
  }

  return (
    <div className="hidden" data-ghost-routes>
      {themeRouting.routes && 
        <>
        <p>The following <b>routes</b> are included:</p>
          <ul>
            {Object.keys(themeRouting.routes).map(route => 
              <li key={route}>
                <code>{route}</code> — based on the <code>{themeRouting.routes[route].template}.hbs</code> template.&nbsp;
                (<a href={`https://${theme}.brightthemes.com${route}`}>{route === '/' ? 'home' : route.replaceAll('/', '')} page</a>)
              </li>
            )}
          </ul>
        </>
      }
     
      {themeRouting.collections && 
        <>
          <p>The following <b>collections</b> are included:</p>
          <ul>
            {Object.keys(themeRouting.collections).map(collection => {
              const template = themeRouting.collections[collection].template
              const filter = themeRouting.collections[collection].filter
              const filterFallback = Object.keys(themeRouting.collections).length === 1 ? 'all posts' : 'all posts that don\'t belong to any other collection'
              return (
                <li key={collection}>
                  <code>{collection}</code> — {filter ? <>posts that match the <code>{filter}</code> filter</> : filterFallback}, using the the <code>{template}.hbs</code> template.&nbsp; { filter ? <> (<a href={`https://${theme}.brightthemes.com${collection}`}>{collection === '/' ? 'home' : collection.replaceAll('/', '')} page</a>)</> : ''}
              </li>
            )})}
          </ul>
        </>
      }
    </div>
  )
}